<template>
  <div id="page-consultant-edit">
    <vx-card v-if="consultant">
      <div slot="no-body" class="px-6 pt-6">
        <ConsultantGeneral
          v-model="consultant"
          :user-value="user"
          @userInput="
            v => {
              user = v;
            }
          "
        />

        <vs-button @click="createConsultant">Speichern</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ConsultantGeneral from "../form/ConsultantGeneral";

export default {
  components: {
    ConsultantGeneral
  },
  data() {
    return {
      consultant: {},
      user: {
        userType: "EMPLOYEE"
      }
    };
  },
  methods: {
    async createConsultant() {
      if (!this.consultant.userID) {
        try {
          let { data } = await this.$apollo.mutate({
            mutation: gql`
              mutation($input: CreateUserInput!) {
                userCreate(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: Object.prepareGqlInput(this.user)
            }
          });

          this.consultant.userID = data.userCreate.id;
          this.user = data.userCreate;
        } catch (err) {
          if (err.graphQLErrors) {
            for (const errDetail of err.graphQLErrors) {
              if (errDetail.message) {
                this.$vs.notify({
                  title: "Fehler",
                  text: errDetail.message,
                  color: "danger",
                  icon: "query_builder",
                  position: "bottom-center"
                });
              }
            }
          }
          return;
        }
      }

      let cResponse = await this.$apollo.mutate({
        mutation: gql`
          mutation($input: CreateConsultantInput!) {
            createConsultant(input: $input) {
              id
            }
          }
        `,
        variables: {
          input: Object.prepareGqlInput(this.consultant)
        }
      });

      await this.$apollo.mutate({
        mutation: gql`
          mutation($user: ID!, $consultant: ID!) {
            userLinkConsultant(user: $user, consultant: $consultant)
          }
        `,
        variables: {
          user: this.consultant.userID,
          consultant: cResponse.data.createConsultant.id
        }
      });

      this.$router.push({ name: "consultant.overview" });
    }
  }
};
</script>
